import { FormControlLabel, Radio } from '@mui/material'
import React from 'react'
import { useFormContext, useWatch } from 'react-hook-form'

import { AuthenticationType } from 'components/status-checks/authentication-form-utils'
import { ObservabilityToolPrometheusAuthenticationUserPasswordDetails } from 'components/status-checks/form/authentication/prometheus/ObservabilityToolPrometheusAuthenticationUserPasswordDetails'
import { type StatusCheckFormValues } from 'components/status-checks/status-checks-form-utils'

export const ObservabilityToolPrometheusAuthenticationUserPasswordOption =
  () => {
    const { control } = useFormContext<StatusCheckFormValues>()

    const [authenticationType] = useWatch<StatusCheckFormValues>({
      control,
      name: ['authenticationType']
    })

    return (
      <>
        <FormControlLabel
          control={<Radio />}
          label="Use Username and Password"
          value={AuthenticationType.UsernamePassword}
        />
        {authenticationType === AuthenticationType.UsernamePassword && (
          <ObservabilityToolPrometheusAuthenticationUserPasswordDetails />
        )}
      </>
    )
  }
